module.exports = __webpack_public_path__ + "img/mcafee.32e49d52.svg";